angular.module('myappointments', [
    //third party
    'angularLocalStorage',
    'gettext',
    'headroom',
    'lodash',
    'ngAnimate',
    'ngTouch',
    'restangular',
    'toaster',
    'ui.bootstrap',
    'ui.router',
    'apEasyScroller',

    'app',

    'aprima-core',
    'aprima-bridge',
    'aprima-config',
    'aprima-legacy-common',
    'aprima-provider-api',
    'aprima-patient-api',
    'aprima-utils'
]);